import { useEffect, useState } from 'react';
import {
  Button,
  Dropdown,
  Grid,
  Header,
  Input,
  Segment,
  Tab,
} from 'semantic-ui-react';
import { communicationSettings } from '../../app/common/options/dashboardOptions/milestoneOptions';
import './communication.css';
import { useStore } from '../../app/stores/store';
import { observer } from 'mobx-react-lite';
import CsCardBox from './CsCardBox';
import NotificationComponent from './NotificationComponent';

function CommunicationSetting() {
  const [selected, setSelected] = useState<string[]>([]);

  const {
    TemplateStore,
    CommunicationStore,
    ApiStore: { metadataGetApi, getElementandMetaData },
  } = useStore();
  const { communicationInput } = CommunicationStore;

  const {
    selectedAssetType,
    selectedElementTypes,
    selectedTemplate,
    selectedTasks,
    selectedSubTasks,
  } = TemplateStore;
  const [selSubTask, setSelSubTask] = useState<any>();
  const [selectedAssetName] = useState(selectedAssetType);
  const [paneStore, setPaneStore] = useState<any>();
  const [getSelectOption, setGetSelectOption] = useState([]);
  const [blockGetUseEffect, setBlockGetUseEffect] = useState<boolean>(true);

  //Add Notification Row
  const [optionsState, setOptionsState] = useState<any>([]);
  const [chosenElemData, setChosenElemData] = useState<any>([]);
  const [notificationDropdown, setNotificationDropdown] = useState<string>('');

  useEffect(() => {
    if (selectedElementTypes?.id) {
      metadataGetApi(selectedElementTypes?.id);
    }
  }, [selectedElementTypes, metadataGetApi]);

  const handleAddItem = () => {
    setNotificationDropdown('');
    setChosenElemData((oldState: any) => [...oldState, ...optionsState]);
    setOptionsState([]);

    setBlockGetUseEffect(false);
    // setGetSelectOption(optionsState[0].split('/')[0]);
    setSelected([...selected, optionsState[0].split('/')[0]]);
    CommunicationStore.setCommunicationScheme2(
      optionsState[0].split('/')[0],
      optionsState[0].split('/')[1],
    );

    const communicationPostStructure = {
      subTaskId: selectedSubTasks?.subTaskId,
      communication: communicationInput.addNewCommunicationTab,
    };
    CommunicationStore.postCommunication(communicationPostStructure);
    setPaneStore(communicationInput.getCommunicationInitScheme);
  };
  const handleDropdownChange = (e: any, data: any) => {
    setNotificationDropdown(e.currentTarget.textContent + '/' + data.value);
    setOptionsState([e.currentTarget.textContent + '/' + data.value]);
  };

  const pane: any =
    paneStore !== undefined
      ? paneStore.map((data: string, i: number) => ({
          menuItem: selected[i],
          render: () => getPanes(data, i),
        }))
      : null;

  //defined once can use it anywhere
  const getPanes = (data: string, i: number) => {
    return (
      <CsCardBox
        key={'key-' + i}
        selectedElementDat={selectedSubTasks?.elements}
        commScheme={data}
      />
    );
  };

  useEffect(() => {
    if (selectedSubTasks !== undefined) {
      setSelSubTask(selectedSubTasks);
    }
    // eslint-disable-next-line
  }, [selectedSubTasks]);

  useEffect(() => {
    getElementandMetaData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Get Saved Communication data
    if (blockGetUseEffect) {
      const communicationData: any = selSubTask?.communication;
      communicationData?.sort((a: any, b: any) =>
        a.status < b.status ? -1 : a.status > b.status ? 1 : 0,
      );
      if (
        communicationData !== undefined &&
        communicationData !== null &&
        communicationData.length !== 0
      ) {
        let actionStatus = '';
        const setArrSelected: any = [];
        communicationData.forEach((data: any) => {
          switch (data.status) {
            case 1:
              actionStatus = 'Start';
              break;
            case 2:
              actionStatus = 'Complete';
              break;
            case 3:
              actionStatus = 'Hold';
              break;
            case 4:
              actionStatus = 'Resume';
              break;
            case 5:
              actionStatus = 'Reject';
              break;
            case 6:
              actionStatus = 'Rework';
              break;
            case 11:
              // actionStatus = 'Notifcation';
              actionStatus = data.notificationName;
              break;
          }
          setArrSelected.push(actionStatus);
        });
        setSelected(setArrSelected);
        communicationInput.getCommunicationInitScheme = communicationData;
        setPaneStore(communicationInput.getCommunicationInitScheme);
      }
    }
    // eslint-disable-next-line
  }, [paneStore, selSubTask, communicationInput]);

  useEffect(() => {
    setPaneStore(communicationInput.getCommunicationInitScheme);
  }, [selected, CommunicationStore, communicationInput]);

  useEffect(() => {
    const communicationData: any = selectedSubTasks?.communication;
    communicationData?.sort((a: any, b: any) =>
      a.status < b.status ? -1 : a.status > b.status ? 1 : 0,
    );
    if (
      communicationData !== undefined &&
      communicationData !== null &&
      communicationData.length !== 0
    ) {
      let actionStatus = '';
      const setArrSelectedLower: any = [];
      communicationData.forEach((data: any) => {
        switch (data.status) {
          case 1:
            actionStatus = 'Start';
            break;
          case 2:
            actionStatus = 'Complete';
            break;
          case 3:
            actionStatus = 'Hold';
            break;
          case 4:
            actionStatus = 'Resume';
            break;
          case 5:
            actionStatus = 'Reject';
            break;
          case 6:
            actionStatus = 'Rework';
            break;
          case 11:
            actionStatus = 'Notification';
            break;
        }
        setArrSelectedLower.push(actionStatus.toLowerCase());
      });

      setGetSelectOption(setArrSelectedLower);
    }
  }, [selectedSubTasks?.communication]);

  // main handle add row for adding pane
  const handleAddRow = (e: any, data: any) => {
    e.preventDefault();
    setBlockGetUseEffect(false);
    setGetSelectOption(data.value);
    if (e.currentTarget.parentElement.className === 'ui label') {
      // Delete communication
      setSelected(
        selected.filter(
          (item) => item !== e.currentTarget.parentElement.textContent,
        ),
      );
      let actionStatus = 0;
      switch (e.currentTarget.parentElement.textContent) {
        case 'Start':
          actionStatus = 1;
          break;
        case 'Complete':
          actionStatus = 2;
          break;
        case 'Hold':
          actionStatus = 3;
          break;
        case 'Resume':
          actionStatus = 4;
          break;
        case 'Reject':
          actionStatus = 5;
          break;
        case 'Rework':
          actionStatus = 6;
          break;
      }
      const communicationDeleteData =
        communicationInput.getCommunicationInitScheme.filter(
          (item: any) => item.status === actionStatus,
        );
      const filteredDelData =
        communicationInput.getCommunicationInitScheme.filter(
          (item: any) => item.status !== actionStatus,
        );
      CommunicationStore.deleteCommunication(
        communicationDeleteData[0].id,
        filteredDelData,
      );
    } else {
      setSelected([...selected, e.currentTarget.textContent]);
      CommunicationStore.setCommunicationScheme(e.currentTarget.textContent);
      const communicationPostStructure = {
        subTaskId: selectedSubTasks?.subTaskId,
        communication: communicationInput.addNewCommunicationTab,
      };
      CommunicationStore.postCommunication(communicationPostStructure);
      setPaneStore(communicationInput.getCommunicationInitScheme);
    }
  };

  function replaceTextWithUnderscores(htmlString: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const elements = doc.querySelectorAll('c');

    elements.forEach((element) => {
      const textContent = element.textContent || '';
      const textWithUnderscores = textContent.replace(/\s+/g, '_');
      element.textContent = textWithUnderscores;
    });

    return doc.body.innerHTML;
  }

  function replaceUnderscoresWithSpaces(htmlString: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const elements = doc.querySelectorAll('c');

    elements.forEach((element) => {
      const textContent = element.textContent || '';
      const textWithSpaces = textContent.replace(/_/g, ' ');
      element.textContent = textWithSpaces;
    });
    return doc.body.innerHTML;
  }

  const saveStatusMsg = async () => {
    updateCommunicationScheme();
    communicationInput.getCommunicationInitScheme.forEach((item: any) => {
      item.subject = item.subject.replace(/&nbsp;/g, '').replace(/\s+/g, ' ');
      item.message = replaceTextWithUnderscores(item.message);
    });
    const communicationPostStructure = {
      subTaskId: selectedSubTasks?.subTaskId,
      communication: communicationInput.getCommunicationInitScheme,
    };
    await CommunicationStore.putCommunication(communicationPostStructure);
    await communicationInput.getCommunicationInitScheme.forEach((item: any) => {
      item.message = replaceUnderscoresWithSpaces(item.message);
    });
  };

  const updateCommunicationScheme = () => {
    communicationInput.getCommunicationInitScheme.forEach((data: any) => {
      if (communicationInput.communicationMsg !== '') {
        const msgUpdateVal = communicationInput.communicationMsg.split('|');
        if (data.status === parseInt(msgUpdateVal[1])) {
          data.message = msgUpdateVal[0];
        }
      }
      if (communicationInput.communicationSubject !== '') {
        const subUpdateVal = communicationInput.communicationSubject.split('|');
        if (data.status === parseInt(subUpdateVal[1])) {
          data.subject = subUpdateVal[0];
        }
      }
    });
    setPaneStore(communicationInput.getCommunicationInitScheme);
  };

  return (
    <>
      <Header
        style={{ marginTop: '80px', marginLeft: '20px' }}
        icon="rocketchat"
        size="huge"
        dividing
        as="h1"
        content="Communication Setting"
        sub
        color="grey"
      />
      <Segment basic className="communication-container scroll">
        <Grid columns={6}>
          <Grid.Column>
            <Input disabled value={selectedAssetName?.typeName} />
          </Grid.Column>
          <Grid.Column>
            <Input disabled value={selectedElementTypes?.elementName} />
          </Grid.Column>
          <Grid.Column>
            <Input disabled value={selectedTemplate?.templateName} />
          </Grid.Column>
          <Grid.Column>
            <Input disabled value={selectedTasks?.taskName} />
          </Grid.Column>
          <Grid.Column>
            <Input disabled value={selectedSubTasks?.subTaskName} />
          </Grid.Column>
          <Grid.Column>
            <Dropdown
              style={{ width: '100%' }}
              placeholder="--Select--"
              search
              selection
              options={communicationSettings}
              onChange={(e, data) => handleAddRow(e, data)}
              value={getSelectOption}
              clearable
              fluid
              multiple
              className="clear-selection"
            />
          </Grid.Column>

          {/* <Grid.Column > */}
          <div style={{ width: '100%', marginBottom: '2rem' }}>
            <NotificationComponent
              handleDropdownChange={handleDropdownChange}
              handleAddItem={handleAddItem}
              chosenElemData={chosenElemData}
              notificationDropdown={notificationDropdown}
            />
          </div>

          {/* </Grid.Column> */}

          <div style={{ left: '0', top: '200px' }}>
            {selected.length > 0 && (
              <>
                <Button
                  positive
                  style={{
                    position: 'absolute',
                    right: '10px',
                  }}
                  onClick={saveStatusMsg}
                >
                  Save
                </Button>
                <Tab panes={pane} onTabChange={updateCommunicationScheme} />
              </>
            )}
          </div>
        </Grid>
      </Segment>
    </>
  );
}

export default observer(CommunicationSetting);
